import { render, staticRenderFns } from "./sub-element-contact.vue?vue&type=template&id=978a7532&scoped=true&"
import script from "./sub-element-contact.vue?vue&type=script&lang=js&"
export * from "./sub-element-contact.vue?vue&type=script&lang=js&"
import style0 from "./sub-element-contact.vue?vue&type=style&index=0&id=978a7532&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978a7532",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2F_snippets%2Fsub_elements%2Fsub-element-contact.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/lang/messages.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2F_snippets%2Fsub_elements%2Fsub-element-contact.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports